import React from "react";
import { useNavigate } from "react-router-dom";

function AdminPanelWebPage() {
  const navigate = useNavigate();

  const groups = [
    {title: "📬 Assistance par e-mail", desc: "Demandes publiques et conversations e-mail.", items: [{title: "Assistance", desc: "Lire, répondre et suivre les demandes.", icon: "📬", path: "/admin/assistance"}]},
    {
      title: "🛡️ Modération",
      desc: "Signalements, alertes et contrôle sécurité.",
      items: [
        {
          title: "Alertes",
          desc: "Vidéos signalées.",
          icon: "🚨",
          path: "/admin/reports"
        },
        {
          title: "Sons à valider",
          desc: "Sons envoyés par les utilisateurs.",
          icon: "🎧",
          path: "/admin/music-validation"
        },
        {
          title: "Notifications",
          desc: "Envoyer annonces.",
          icon: "🔔",
          path: "/admin/notifications"
        },
        {
          title: "Outils",
          desc: "Config technique.",
          icon: "⚙️",
          path: "/admin/tools"
        }
      ]
    },

    {
      title: "👥 Utilisateurs",
      desc: "Gestion des membres, staff et certifications.",
      items: [
        {
          title: "Membres",
          desc: "Gestion users.",
          icon: "👥",
          path: "/admin/users"
        },
        {
          title: "Activité Staff",
          desc: "Connexions et actions enregistrées.",
          icon: "📋",
          path: "/admin/staff-activity"
        },
        {
          title: "Lives signalés",
          desc: "Examiner les signalements des spectateurs.",
          icon: "🚨",
          path: "/admin/live-reports"
        },
        {
          title: "Staff",
          desc: "Créer staff.",
          icon: "🛡️",
          path: "/admin/staff"
        },
        {
          title: "Badges",
          desc: "Vérifications.",
          icon: "📑",
          path: "/admin/certification"
        },
        {
          title: "EVO Agences",
          desc: "Surveiller et contrôler.",
          icon: "🏢",
          path: "/admin/agencies"
        }
      ]
    },

    {
      title: "💰 Argent & boutique",
      desc: "Achats, gains, cadeaux et packs coins.",
      items: [
        {
          title: "Achats",
          desc: "Flux financier.",
          icon: "💰",
          path: "/admin/transactions"
        },
        {
          title: "Gains",
          desc: "Commissions app.",
          icon: "💼",
          path: "/admin/gains"
        },
        {
          title: "Retraits",
          desc: "Demandes PayPal créateurs.",
          icon: "💶",
          path: "/admin/withdrawals"
        },
        {
          title: "Cadeaux",
          desc: "Gérer catalogue.",
          icon: "🎁",
          path: "/admin/gifts"
        },
        {
          title: "Packs",
          desc: "Tarifs coins.",
          icon: "🪙",
          path: "/admin/coin-packs"
        }
      ]
    },

    {
      title: "📊 Plateforme",
      desc: "Statistiques et contenu global.",
      items: [
        {
          title: "Stats",
          desc: "Stats détaillées.",
          icon: "📊",
          path: "/admin/stats"
        },
        {
          title: "Musique",
          desc: "Sons EVO.",
          icon: "🎵",
          path: "/admin/music"
        }
      ]
    }
  ];

  return (
    <div className="admin-home">
      <style>{`
        * {
          box-sizing: border-box;
        }

        .admin-home {
          min-height: 100vh;
          background:
            radial-gradient(circle at top left, rgba(0, 140, 255, 0.08), transparent 30%),
            #02070d;
          color: #fff;
        }

        .admin-header {
          height: 76px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 28px;
          background: rgba(3, 18, 32, 0.96);
          border-bottom: 1px solid rgba(0, 242, 255, 0.14);
          position: sticky;
          top: 0;
          z-index: 20;
          backdrop-filter: blur(12px);
        }

        .admin-header-side {
          width: 100px;
        }

        .admin-header-center {
          flex: 1;
          text-align: center;
        }

        .admin-title {
          font-size: 16px;
          font-weight: 900;
          letter-spacing: 1.3px;
        }

        .admin-subtitle {
          color: #00dff0;
          font-size: 9px;
          font-weight: 800;
          margin-top: 3px;
          letter-spacing: 1.4px;
        }

        .admin-quit {
          background: rgba(255, 0, 64, 0.14);
          color: #ff476f;
          border: 1px solid rgba(255, 71, 111, 0.35);
          padding: 7px 12px;
          border-radius: 9px;
          font-size: 9px;
          font-weight: 900;
          cursor: pointer;
          transition: 0.18s ease;
        }

        .admin-quit:hover {
          background: #ff0040;
          color: #fff;
          transform: translateY(-1px);
        }

        .admin-content {
          width: min(1180px, calc(100% - 36px));
          margin: 0 auto;
          padding: 22px 0 70px;
        }

        .admin-group {
          margin-bottom: 26px;
        }

        .admin-group-head {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          gap: 20px;
          margin-bottom: 10px;
          padding: 0 2px;
        }

        .admin-group-title {
          font-size: 15px;
          font-weight: 900;
          line-height: 1.2;
        }

        .admin-group-desc {
          color: #60798a;
          font-size: 10px;
          margin-top: 4px;
        }

        .admin-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
          gap: 9px;
        }

        .admin-card {
          min-height: 86px;
          padding: 13px;
          display: flex;
          align-items: center;
          gap: 11px;
          background: linear-gradient(
            145deg,
            rgba(8, 28, 45, 0.94),
            rgba(4, 18, 30, 0.94)
          );
          border: 1px solid rgba(0, 242, 255, 0.12);
          border-radius: 12px;
          cursor: pointer;
          transition:
            transform 0.16s ease,
            border-color 0.16s ease,
            background 0.16s ease,
            box-shadow 0.16s ease;
        }

        .admin-card:hover {
          transform: translateY(-2px);
          border-color: rgba(0, 242, 255, 0.38);
          background: linear-gradient(
            145deg,
            rgba(8, 35, 55, 0.98),
            rgba(4, 21, 34, 0.98)
          );
          box-shadow: 0 8px 22px rgba(0, 0, 0, 0.24);
        }

        .admin-icon {
          width: 40px;
          height: 40px;
          flex: 0 0 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          background: rgba(0, 140, 255, 0.10);
          border: 1px solid rgba(0, 242, 255, 0.10);
          font-size: 20px;
        }

        .admin-card-text {
          flex: 1;
          min-width: 0;
        }

        .admin-card-title {
          font-size: 12px;
          font-weight: 900;
          color: #fff;
        }

        .admin-card-desc {
          color: #718797;
          font-size: 9px;
          margin-top: 4px;
          line-height: 1.3;
        }

        .admin-arrow {
          width: 27px;
          height: 27px;
          flex: 0 0 27px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0, 140, 255, 0.12);
          color: #4db5ff;
          font-size: 18px;
          font-weight: 900;
          transition: 0.16s ease;
        }

        .admin-card:hover .admin-arrow {
          background: #008cff;
          color: #fff;
          transform: translateX(2px);
        }

        .admin-footer {
          margin-top: 34px;
          text-align: center;
          color: #263746;
          font-size: 9px;
          font-weight: 700;
        }

        @media (min-width: 1150px) {
          .admin-grid {
            grid-template-columns: repeat(5, 1fr);
          }
        }

        @media (max-width: 760px) {
          .admin-header {
            height: 68px;
            padding: 10px 14px;
          }

          .admin-header-side {
            width: 76px;
          }

          .admin-title {
            font-size: 13px;
          }

          .admin-content {
            width: calc(100% - 22px);
            padding-top: 16px;
          }

          .admin-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 8px;
          }

          .admin-card {
            min-height: 78px;
            padding: 10px;
          }

          .admin-icon {
            width: 34px;
            height: 34px;
            flex-basis: 34px;
            font-size: 17px;
          }

          .admin-card-title {
            font-size: 11px;
          }

          .admin-card-desc {
            font-size: 8px;
          }

          .admin-arrow {
            display: none;
          }
        }

        @media (max-width: 430px) {
          .admin-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <header className="admin-header">
        <div className="admin-header-side" />

        <div className="admin-header-center">
          <div className="admin-title">PANNEAU ADMIN</div>
          <div className="admin-subtitle">EVO CONTROL CENTER</div>
        </div>

        <div
          className="admin-header-side"
          style={{
            display: "flex",
            justifyContent: "flex-end"
          }}
        >
          <button
            className="admin-quit"
            onClick={() => navigate("/")}
          >
            QUITTER ×
          </button>
        </div>
      </header>

      <main className="admin-content">
        {groups.map((group) => (
          <section
            className="admin-group"
            key={group.title}
          >
            <div className="admin-group-head">
              <div>
                <div className="admin-group-title">
                  {group.title}
                </div>

                <div className="admin-group-desc">
                  {group.desc}
                </div>
              </div>
            </div>

            <div className="admin-grid">
              {group.items.map((item) => (
                <div
                  key={item.title}
                  className="admin-card"
                  onClick={() => navigate(item.path)}
                >
                  <div className="admin-icon">
                    {item.icon}
                  </div>

                  <div className="admin-card-text">
                    <div className="admin-card-title">
                      {item.title}
                    </div>

                    <div className="admin-card-desc">
                      {item.desc}
                    </div>
                  </div>

                  <div className="admin-arrow">
                    ›
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}

        <div className="admin-footer">
          EVO LIVE Admin v1.0.5
        </div>
      </main>
    </div>
  );
}

export default AdminPanelWebPage;
